module.exports = __webpack_public_path__ + "img/4.832de98d.jpg";